import * as FootballContextUtils from "../../sports/football/utils/context-utils";
import YardConverter from "../../sports/common/utils/yard-converter";
import TeamSide from "../../sports/football/enums/team-side";

const FootballSerializer = {
    _formatFieldPosition(fieldLength, fieldPosition, awayTeam, homeTeam) {
        const yardConverter = new YardConverter(fieldLength);
        const { teamSide, yard } =
            yardConverter.convertFromFieldPosition(fieldPosition);

        return `${
            teamSide === TeamSide.Home
                ? homeTeam?.abbrName || TeamSide.Home
                : awayTeam?.abbrName || TeamSide.Visitor
        }${yard}`;
    },
    _formatGameContextFieldPosition(gameContext) {
        let value = null;
        if (gameContext) {
            const { gameConfig } = gameContext;
            if (gameConfig) {
                const { awayTeam, homeTeam } = gameContext;
                value = this._formatFieldPosition(
                    gameConfig.general.fieldLength,
                    gameContext.fieldPosition,
                    awayTeam,
                    homeTeam
                );
            }
        }

        return value;
    },
    serializeGameContext(gameContext) {
        if (!gameContext) {
            return null;
        }

        const { gameClock, score } = gameContext;
        const json = gameContext.toJSON ? gameContext.toJSON() : gameContext;

        // This UI-facing payload shadows the clock's now() method with a
        // number — strip _type so the object can never be revived as a
        // clock instance whose now is not callable.
        json.gameClock = { ...json.gameClock };
        delete json.gameClock._type;
        json.gameClock.now = gameClock.now();
        json.gameClock.elapsedTime = gameClock.getElapsedTime();
        json.yardsToFirstDown =
            FootballContextUtils.getYardsToFirstDownFriendly(
                gameContext,
                gameContext.gameConfig
            );
        [json.homeScore, json.visitorScore] = score;
        json.fieldPositionFormatted =
            this._formatGameContextFieldPosition(gameContext);
        json.period = gameContext.getCurrentPeriod();
        json.overtimePeriod = gameContext.getOvertimePeriod();
        json.currentHomeTimeouts = gameContext.getCurrentHomeTimeouts();
        json.currentVisitorTimeouts = gameContext.getCurrentAwayTimeouts();
        json.overtimeNotification = gameContext.getOvertimeNotification();

        return json;
    }
};

export default FootballSerializer;
